export const POSTCODE_AREA_BOUNDARIES = {
  type: "vector",
  url: "mapbox://mapbox.boundaries-pos1-v3",
};

export const POSTCODE_DISTRICT_BOUNDARIES = {
  type: "vector",
  url: "mapbox://mapbox.boundaries-pos2-v3",
};

export const POSTCODE_SECTOR_BOUNDARIES = {
  type: "vector",
  url: "mapbox://mapbox.boundaries-pos3-v3",
};

export const POSTCODE_UNIT_BOUNDARIES = {
  type: "vector",
  url: "mapbox://mapbox.boundaries-pos4-v3",
};

export const POSTCODE_DISTRICT_BOUNDARIES_ID = "postcodeDistrictBoundaries";
export const POSTCODE_SECTOR_BOUNDARIES_ID = "postcodeSectorBoundaries";
export const POSTCODE_UNIT_BOUNDARIES_ID = "postcodeUnitBoundaries";
export const POSTCODE_LEVEL_MATRIX_ID = "postcodeLevelMatrix";

export const BOUNDARIES_ID_BY_LEVEL = {
  OUTER: POSTCODE_DISTRICT_BOUNDARIES_ID,
  SECTOR: POSTCODE_SECTOR_BOUNDARIES_ID,
  POSTCODE: POSTCODE_UNIT_BOUNDARIES_ID,
};
